import dayjs, { extend } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isTodayPlugin from 'dayjs/plugin/isToday';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import UTC from 'dayjs/plugin/utc';

extend(UTC);
extend(LocalizedFormat);
extend(isTodayPlugin);
extend(duration);
extend(customParseFormat);

export type DateArg = Date | null | string | undefined;

export function formatDateStringToMDY(dateString: string): string {
  return dayjs(dateString).format('MM-DD-YYYY');
}

export function formatScheduleDate(date: DateArg = new Date()): string {
  return dayjs(date).format('YYYY-MM-DD');
}

export function formatSecondsToHMS(seconds: string) {
  const parsedSeconds = parseFloat(seconds);
  if (isNaN(parsedSeconds)) {
    return '--:--:--';
  }
  return dayjs.duration(parsedSeconds, 'seconds').format('HH:mm:ss');
}

export function isToday(date: DateArg): boolean {
  return dayjs(date).isToday();
}

export function stripZoneAnnotation(timestamp: string): string {
  return timestamp.replace(/\[.*?\]$/, '');
}
export { dayjs };
